module.exports = __webpack_public_path__ + "img/jcb.8bb2d74d.svg";